export type FreedomAppId = "erp" | "stock";

export type FreedomApp = {
  id: FreedomAppId;
  name: string;
  subtitle: string;
  href: string;
};

function resolveFreedomAppUrls(): Record<FreedomAppId, string> {
  if (typeof window === "undefined") {
    return {
      erp: "http://localhost:3000",
      stock: "http://localhost:3002",
    };
  }

  const { hostname, protocol } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return {
      erp: "http://localhost:3000",
      stock: "http://localhost:3002",
    };
  }

  if (hostname.endsWith("freedombrand.local")) {
    return {
      erp: `${protocol}//management.freedombrand.local:3000`,
      stock: `${protocol}//stock.freedombrand.local:3002`,
    };
  }

  return {
    erp: "https://management.freedombrand.la",
    stock: "https://stock.freedombrand.la",
  };
}

export function getFreedomApps(): FreedomApp[] {
  const urls = resolveFreedomAppUrls();

  return [
    {
      id: "erp",
      name: "Freedom®",
      subtitle: "Admin ERP",
      href: urls.erp,
    },
    {
      id: "stock",
      name: "Freedom®",
      subtitle: "Stock & POS",
      href: urls.stock,
    },
  ];
}

export function getFreedomApp(id: FreedomAppId): FreedomApp {
  const app = getFreedomApps().find((item) => item.id === id);
  if (!app) {
    throw new Error(`Unknown freedom app: ${id}`);
  }
  return app;
}

export function getStockOrderDetailUrl(orderId: string): string {
  return `${getFreedomApp("stock").href}/app/orders/${orderId}`;
}
